// extracted by mini-css-extract-plugin
export default {"checkbox":"input_checkbox__N6n9d"};